import { ContractStep } from "src/api/contract/contract-types";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import { BaseButton } from "../BaseButton";
import { BaseModal } from "../BaseModal";
import BaseSectionTitle from "./BaseSectionTitle";
// 임대상품에서 수정 불가능한 계약 상태 목록
const DisabledStatesForGeneralProducts: Array<string> = [
  ContractStep.APPLY_CANCEL, // 신청취소
  ContractStep.TERMINATE_COMPLETE, // 해지완료
  ContractStep.USE_COMPLETE, // 이용완료

  // ContractStep.TERMINATE_RECEIVED, // 해지접수
];
// 예약상품(productType === "TIME_COURT")에서 수정 불가능한 계약 상태 목록
const DisabledStatesForTimeCourt: Array<string> = DisabledStatesForGeneralProducts.concat([
  ContractStep.CONTRACT_ACCEPT,
  ContractStep.USE_APPROVAL,
  ContractStep.USE_PROGRESS,
  ContractStep.USE_COMPLETE,
]);

type props = {
  title: string;
  className?: string;
  children?: React.ReactNode;
  isEditable?: boolean;
  setIsEditable?: Function;
  onClickSave?: Function;
  saveDisabled?: boolean;
  commonModals?: any;
  popupState?: boolean;
  setPopupState?: any;
  editConfrim?: boolean;
  setEditConfrim?: any;
  // 저장 확인 모달 문구 (섹션별 override용, 미지정 시 기본 문구 사용)
  editConfrimTitle?: string;
  editConfrimMessage?: React.ReactNode;
  // true면 확인 클릭 시 저장 호출 직후 확인 모달을 즉시 닫음 (비동기 결과를 기다리지 않음)
  closeConfirmOnClick?: boolean;
  disabledState?: [status: string, productType?: string];
  // 수정 버튼 강제 비활성화 (disabledState 계산 결과와 별개로 true면 무조건 disabled)
  editBtnDisabled?: boolean;
  noHashLink?: boolean;
};

export const ArticleSection = ({
  title,
  className,
  children,
  isEditable,
  setIsEditable,
  onClickSave,
  saveDisabled,
  commonModals,
  popupState,
  setPopupState,
  editConfrim,
  setEditConfrim,
  editConfrimTitle,
  editConfrimMessage,
  closeConfirmOnClick,
  disabledState,
  editBtnDisabled,
  noHashLink,
}: props) => {
  if (disabledState === undefined) {
    disabledState = ["", ""];
  }
  const { isAuthority } = usePartnerAuthority();

  // 수정 버튼 disabled 여부 계산
  const contractStep = disabledState?.[0] || "";
  const productType = disabledState?.[1] || "";
  const isTimeCourt = productType === "TIME_COURT";
  const disabledStates = isTimeCourt ? DisabledStatesForTimeCourt : DisabledStatesForGeneralProducts;
  const isButtonDisabled = disabledStates.includes(contractStep) || !!editBtnDisabled;

  return (
    <article className={`contents-container__wrap-article full-width ${className || ""}`}>
      {isAuthority("w") && onClickSave && setIsEditable && (
        <div className="contents-container__edit-area">
          {isEditable ? (
            <div className="flex-center">
              <BaseButton type="button" className="size-small color-white mr10" title={"취소"} onClick={() => setIsEditable(false)} />
              <BaseButton
                type="button"
                className="size-small"
                title={"저장"}
                disabled={saveDisabled}
                onClick={() => {
                  if (!saveDisabled) {
                    setEditConfrim(true);
                  }
                }}
              />
            </div>
          ) : (
            <button
              className="base-edit-btn"
              disabled={isButtonDisabled}
              onClick={() => setIsEditable(true)}
            />
          )}
        </div>
      )}
      <BaseSectionTitle title={title} noHashLink={noHashLink} />
      <section className="contents-container__1160">{children}</section>
      {popupState && (
        <BaseModal isOpen={popupState} btnRightTitle="확인" onClick={() => setPopupState(false)} title={commonModals.title}>
          {commonModals.subTitle && <p>{commonModals.subTitle}</p>}
          <p>{commonModals.message}</p>
        </BaseModal>
      )}
      {editConfrim && (
        <BaseModal
          isOpen={editConfrim}
          btnLeftTitle="취소"
          btnRightTitle="확인"
          onClick={() => {
            if (onClickSave) {
              onClickSave();
            }
            if (closeConfirmOnClick) {
              setEditConfrim(false);
            }
          }}
          onClose={() => setEditConfrim(false)}
          title={editConfrimTitle ?? title}
        >
          {editConfrimMessage ?? <p>저장하시겠습니까?</p>}
        </BaseModal>
      )}
    </article>
  );
};
